module.exports = {"TXTCLI_Select_All":{"id":"TXTCLI_Select_All","defaultMessage":"Select All","track":"Select All"}}